import { render, staticRenderFns } from "./ContactAs.vue?vue&type=template&id=30fb34aa&"
import script from "./ContactAs.vue?vue&type=script&lang=js&"
export * from "./ContactAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports